import {ImageWithFallback} from "@/components";
import Link from "next/link";

export default function ServiceCard({
                                        desc,
                                        image,
                                        title,
                                        fullDescMode = false,
                                        activeHover = true,
                                        link = "/",
                                        h2Title = true
                                    }) {

    const classes = {
        parent: `block w-full bg-white border-2 border-pol-blue-light px-4 py-3.5 lg:p-3 hover:brightness-100 ${activeHover ? "group hover:border-pol-blue duration-300" : ""} ${fullDescMode ? "rounded-[1.625rem]" : "rounded-t-[1.625rem] rounded-br-[1.625rem] rounded-bl-[1.063rem]"}`,
        imageContainer: `rounded-[0.875rem] hidden lg:block ml-4 ${activeHover ? "group-hover:bg-gradient-to-bl group-hover:from-pol-orange-dark group-hover:to-pol-orange-dark group-hover:outline-pol-orange-dark duration-300" : ""} ${fullDescMode ? "w-[3.875rem] h-[3.875rem] min-w-[3.875rem] p-3.5 outline outline-2 outline-pol-light bg-gradient-to-bl from-white to-pol-light" :
            "w-[6.25rem] h-[6.438rem] min-w-[6.25rem] p-[1.375rem] our-services-gradient"}`
    }

    return (
        <Link href={link}
              className={classes.parent}>
            <div className={`w-full flex ${fullDescMode ? "items-center" : ""}`}>
                {
                    image ?
                        <div className={classes.imageContainer}>
                            {
                                <div className="relative w-full h-full">
                                    <ImageWithFallback
                                        src={image}
                                        alt={title}
                                        className="object-cover"
                                        fill/>
                                </div>
                            }
                        </div> : null
                }

                <div className="flex flex-col pt-1.5 w-full truncate">
                    {
                        h2Title ?
                            <h2 className="font-bold text-xl text-pol-dark-800 truncate">{title}</h2> :
                            <p className="font-bold text-xl text-pol-dark-800 truncate">{title}</p>
                    }

                    {
                        fullDescMode ? null :
                            <p className="text-sm text-pol-dark-brown-4 mt-3.5 lg:mt-2.5 leading-normal line-clamp-2 lg:line-clamp-3 whitespace-normal min-h-[1.2rem]">{desc}</p>
                    }
                </div>
            </div>
            {
                fullDescMode ?
                    <p className="text-sm text-pol-dark-brown-4 mt-3 mb-2.5 leading-normal line-clamp-2 min-h-[1.2rem]">{desc}</p>
                    : null
            }
        </Link>
    )
}
